<div class="popover-trigger" (click)="toggle()">
  <ng-content select="[popoverTrigger]"></ng-content>
</div>

<ng-template #popoverContentWrapper>
  <div class="popover-content">
    @if (showCloseButton()) {
      <button class="popover-close-button" (click)="close()" aria-label="Закрыть" type="button">
        <mat-icon>close</mat-icon>
      </button>
    }
    <ng-container *ngTemplateOutlet="contentTemplate(); context: { close: closeFn }"></ng-container>
  </div>
</ng-template>
